/**
 * The edit check specification's summary, recomputed from the checks that
 * exist (2026-09-17).
 *
 * The panel used to write `totalChecks` when a check was deleted — a field
 * nothing reads — leaving `checkCount` and the two breakdowns as the
 * generation had written them. Verification's J6 compares exactly those three
 * with the checks subcollection, so one delete on this screen made the
 * specification report itself as wrong. The generation counts the same way
 * (functions/src/editChecks/writeEditCheckSpec.ts, tallyChecks).
 */

export interface SpecSummary {
  checkCount: number;
  categoryBreakdown: Record<string, number>;
  severityBreakdown: Record<string, number>;
  /** The panel's own count of the checks left switched on. */
  activeChecks: number;
}

type CountableCheck = { category?: string; severity?: string; active?: boolean };

export function specSummaryOf(checks: CountableCheck[]): SpecSummary {
  const categoryBreakdown: Record<string, number> = {};
  const severityBreakdown: Record<string, number> = { error: 0, warning: 0, query: 0 };
  let activeChecks = 0;
  for (const c of checks) {
    const category = String(c.category ?? '');
    if (category) categoryBreakdown[category] = (categoryBreakdown[category] || 0) + 1;
    const severity = String(c.severity ?? '');
    if (severity in severityBreakdown) severityBreakdown[severity]++;
    if (c.active) activeChecks++;
  }
  return { checkCount: checks.length, categoryBreakdown, severityBreakdown, activeChecks };
}
